import {customAxiosBE} from "../config";

export async function getStationScheduler(depId, signal) {
    return await customAxiosBE.get(`station-schedule/${depId}`, {signal});
}
